module.exports = __webpack_public_path__ + "img/1674790.cf82abc7.png";